import * as ActionTypes from 'actions/documents'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  documents: [],
}

// Updates error message to notify about the failed fetches.
export default function getDocuments(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.DOCUMENTS_GETING_DOCUMENTS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.DOCUMENTS_RECEIVED_DOCUMENTS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        documents: action.documents,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/documents.js